import { render, staticRenderFns } from "./WxOpenAppTip.vue?vue&type=template&id=3a84336c&scoped=true"
import script from "./WxOpenAppTip.vue?vue&type=script&lang=ts"
export * from "./WxOpenAppTip.vue?vue&type=script&lang=ts"
import style0 from "./WxOpenAppTip.vue?vue&type=style&index=0&id=3a84336c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a84336c",
  null
  
)

export default component.exports